var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    fill: "url(#paint0_linear_1999_5021)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.04297C12.4418 7.04297 12.8 7.3759 12.8 7.78659L12.8 14.9148L14.6343 13.2097C14.9467 12.9193 15.4533 12.9193 15.7657 13.2097C16.0781 13.5001 16.0781 13.971 15.7657 14.2614L13.3199 16.5348C12.591 17.2124 11.409 17.2124 10.6801 16.5348L8.23431 14.2614C7.9219 13.971 7.9219 13.5001 8.23431 13.2097C8.54673 12.9193 9.05327 12.9193 9.36569 13.2097L11.2 14.9148L11.2 7.78659C11.2 7.3759 11.5582 7.04297 12 7.04297Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1999_5021",
    x1: 10.4507,
    y1: 17.2715,
    x2: 17.0922,
    y2: 6.81634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A61FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#F237BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA8EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC4A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadActive);
export default __webpack_public_path__ + "static/media/download-active.122f4c0695f8e853923b5bce775ab3f2.svg";
export { ForwardRef as ReactComponent };